import script from "./CartView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartView.vue?vue&type=script&setup=true&lang=ts"

import "./CartView.vue?vue&type=style&index=0&id=4545ac50&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4545ac50"]])

export default __exports__